<template>
  <div id="Search">
    <h3>搜索 "<span>{{$route.params.keywords}}</span>"</h3>
    <div class="">
      <Empty v-if="!search_data.list.length"/>
      <Curriculum v-else data_lineLen="5" :data_list="search_data.list"/>
    </div>
    <div class="pageMod">
      <a-pagination
              show-less-items
              v-model:current="search_data.pageNo"
              :default-current="search_data.defaultCurrent"
              :total="search_data.totalCount"
              :pageSize="search_data.pageSize"
              @change="onPageChange"
      />
    </div>
  </div>
</template>

<script>
  import Curriculum from "@c/course/Curriculum";
  import {Empty, Pagination} from "ant-design-vue";
  import { search } from "@/api";
  import {getUserId} from '@/utils/methods.js';
  import { searchAnalys } from "../../utils/AnalysysAgent";
  export default {
    name: "Search",
    components: {
      Curriculum,
      Empty,
      [Pagination.name]: Pagination,
    },
    data() {
      return {
        userId: getUserId(),
        search_data: {
          list: [],
          pageNo: 1, // 当前页数
          pageSize: 30, // 每页条数
          defaultCurrent: 1, // 默认页数
          totalCount: 0,// 总页数
        },
      };
    },
    methods: {
      onPageChange(current, pageSize) {
        console.log(current, pageSize);
        this.search_data.current = current;
        this.search_fn();
      },
      search_fn() {

        search({
          type:'2', // '1'资讯,'2'云课堂,'3'会议,'4'病例,'5'用户,'6'科普患教,'7'编译文章，'8'科室主页,'9'百家关注,'10'短视频，0表示全部
          keywords:this.$route.params.keywords,
          order: 'desc',
          pageno: this.search_data.pageNo,
          pagesize: this.search_data.pageSize,
        }).then(res=>{
          console.log('search',res);
          if(res.data.code === 1){
            this.search_data.list = res.data.list;
            this.search_data.totalCount = res.data.page.totalCount;
          }else{
            this.search_data.list = [];
            this.search_data.totalCount = 0;
          }
          searchAnalys(res.data.list.length>0?true:false,Number(res.data.list.length),false,String(this.$route.params.keywords),false,'云课堂搜索')
        })
      },
      searchDataInit_fn(){
        this.search_data.list = [];
        this.search_data.pageNo = 1;
        this.search_data.pageSize = 30;
        this.search_data.defaultCurrent = 1;
        this.search_data.totalCount = 0;
      }
    },
    mounted() {
      document.title = '搜索';
      this.search_fn();
    },
    watch:{
      $route(){
        this.searchDataInit_fn();
        this.search_fn();
      }
    }
  }
</script>

<style scoped lang="scss">
  #Search {
    @extend %safetyWidth;

    h3 {
      font-size: 20px;
      margin-bottom: 20px;

      span{
        color: red;
      }
    }
  }

  .ant-empty {
    margin: 100px 0;
  }

  .pageMod {
    text-align: center;
  }
</style>
